import React, { createContext, useCallback, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

export const ToastContext = createContext({
  showSuccess: _ => {},
  showError: _ => {},
});

export const ToastProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [severity, setSeverity] = useState("success");
  const showSuccess = useCallback((text) => {
    setSeverity("success");
    setText(text);
    setOpen(true);
  }, []);
  const showError = useCallback((text) => {
    setSeverity("error");
    setText(text);
    setOpen(true);
  }, []);

  return (
    <ToastContext.Provider value={{ showSuccess, showError }}>
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={severity} sx={{ width: "100%" }}>
          {text}
        </Alert>
      </Snackbar>
      {children}
    </ToastContext.Provider>
  );
};
